import { useField } from "formik";
import React, { memo, useEffect } from "react";
import styled from "styled-components";
import { debounce } from "../../utilities/debounce";
import { useLanguage } from "../LangTranslation/LanguageContext";

const defaultStyle = {
  // marginTop: "10px",
  color: "#4e5d78",
  outline: "none",
  width: "100%",
  fontFamily: "Inter",
  fontWeight: "400",
  border: "1px solid #CBCBCB",
  padding: "10px",
  borderRadius: "15px",
  backgroundColor: "#f5f5f5",
};

export const StyledLabel = styled.label`
  color: #535559;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  margin-right: ${(props) => (props.isCheckbox ? "0px" : "10px")};
`;

export const FormikLabel = ({ name, ...restProps }) => {
  // const { language } = useLanguage();

  return (
    <StyledLabel
      className="form-label"
      // className={`form-label ${language === "ar" ? "w-100 text-start" : ""}`}
      htmlFor={name}
      {...restProps}
    ></StyledLabel>
  );
};

function FormikInput({
  name = "",
  magic = false,
  label = "",
  textArea = false,
  onChange,
  disabled,
  type = "text",
  style,
  inputClassName,
  maxLength,
  handleOnBlur = () => {},
  ...restProps
}) {
  const [field, meta] = useField(name);
  const { onChange: onInputChange, value, ...restFieldProps } = field;
  const { touched, error } = meta;
  var dtToday = new Date();

  var month = dtToday.getMonth() + 1;
  var day = dtToday.getDate();
  var year = dtToday.getFullYear();
  if (month < 10) month = "0" + month.toString();
  if (day < 10) day = "0" + day.toString();

  var maxDate = year + "-" + month + "-" + day;

  const handleChangeInput = (e) => {
    onInputChange(e);
    if (onChange) {
      debounce(onChange, 200, [e]);
    }
  };

  const getValuesBasedProps = () => {
    if (type === "checkbox") {
      return { checked: value };
    }
    return {
      value:
        typeof value !== "undefined" && typeof value !== "boolean" ? value : "",
    };
  };

  // disable scroll increment on input type number

  useEffect(() => {
    const handleWheel = (event) => {
      if (document.activeElement.type === "number") {
        event.preventDefault();
      }
    };
    if (type === "number") {
      window.addEventListener("wheel", handleWheel, { passive: false });
    }

    return () => {
      if (type === "number") window.removeEventListener("wheel", handleWheel);
    };
  }, [type]);
  return (
    <>
      {label && <FormikLabel name={name}>{label}</FormikLabel>}
      {textArea ? (
        <textarea
          {...restProps}
          {...restFieldProps}
          onBlur={handleOnBlur}
          title={value || ""}
          id={name}
          name={name}
          value={value || ""}
          rows={4}
          disabled={disabled}
          style={{ ...defaultStyle, ...style }}
          onChange={handleChangeInput}
          maxLength={maxLength}
        />
      ) : (
        <input
          {...restProps}
          {...restFieldProps}
          id={magic ? name + "1" : name}
          name={name}
          {...getValuesBasedProps()}
          type={type}
          min={type === "date" ? maxDate : ""}
          style={
            type !== "checkbox" ? { ...defaultStyle, ...style } : { ...style }
          }
          onBlur={handleOnBlur}
          title={value || ""}
          disabled={disabled}
          onChange={handleChangeInput}
          maxLength={maxLength}
          className={`${
            type === "checkbox"
              ? "form-check-input"
              : "form-control number-input"
          } ${inputClassName}`}
        />
      )}
      {touched && error && <span className="ps-2 error-message">{error}</span>}
    </>
  );
}

export default memo(FormikInput);
